// extracted by mini-css-extract-plugin
module.exports = {"wrap":"FollowKnownIssuesDialog-wrap","noButton":"FollowKnownIssuesDialog-noButton","yesButton":"FollowKnownIssuesDialog-yesButton"};